
<div id="producte-form" ng-cloak  class="mdl-cell mdl-cell--12-col">
          <itec-button  label="{{::'DEFAULT_ACTUALITZAR_ROLS' | translate}}"
                        ng-click-function="ctrl.actualitzarrols()">
          </itec-button>

          <itec-button  label="{{::'DEFAULT_GUARDAR' | translate}}"
                        ng-click-function="ctrl.func()">
          </itec-button>
          <itec-button  label="{{::'DEFAULT_TORNAR' | translate}}"
                        ng-click-function="ctrl.back()">
          </itec-button>
</div>


<itec-tree      items="ctrl.rootTreeNodeCollection"
                expanded-collection="ctrl.expandedCollection"
                children="ctrl.loadChildren(object)"
                tree-tracking="ctrl.treeTracking"
                show-node="ctrl.filterNode"
                selected="ctrl.selected"
                order-by="order"
                expand-in-all-row="false"
                item-name="object">

    <div  class="mdl-grid mdl-grid--no-spacing">
        <div class="mdl-cell mdl-cell--12-col">
            <span ng-if="::object.type === 'tema'">
                <div class="mdl-grid mdl-grid--no-spacing">
                    <div class="mdl-cell mdl-cell--4-col">
                    <span>{{::object.messageKey | translate}}</span>
                    </div>
                     <div class="mdl-cell mdl-cell--2-col">
                        <itec-checkbox
                            name="read"
                            ng-model="object.read"
                            ng-change-function="ctrl.onChangeReadTheme(object)"
                            label="{{::'DEFAULT_VEURE' | translate}}">
                        </itec-checkbox>
                    </div>
                     <div class="mdl-cell mdl-cell--2-col">
                        <itec-checkbox
                            name="add"
                            ng-model="object.add"
                            ng-change-function="ctrl.onChangeAddTheme(object)"
                            label="{{::'DEFAULT_AFEGIR' | translate}}">
                        </itec-checkbox>
                    </div>
                     <div class="mdl-cell mdl-cell--2-col">
                        <itec-checkbox
                            name="edit"
                            ng-model="object.edit"
                            ng-change-function="ctrl.onChangeEditTheme(object)"
                            label="{{::'DEFAULT_EDITAR' | translate}}">
                        </itec-checkbox>
                    </div>
                     <div class="mdl-cell mdl-cell--2-col">
                        <itec-checkbox
                            name="delete"
                            ng-model="object.delete"
                            ng-change-function="ctrl.onChangeDeleteTheme(object)"
                            label="{{::'DEFAULT_ESBORRAR' | translate}}">
                        </itec-checkbox>
                    </div>

                </div>
            </span>
            <span ng-if="::object.type === 'vista'">
                <div class="mdl-grid mdl-grid--no-spacing">
                    <div class="mdl-cell mdl-cell--4-col">
                        <span>{{::"administracio.producte.vistes." + object.nom | translate}}</span>
                    </div>

                    <div class="mdl-cell mdl-cell--2-col">
                        <itec-checkbox
                            name="read"
                            ng-model="object.read"
                            ng-change-function="ctrl.onChangeReadTheme(object)"
                            label="{{::'DEFAULT_VEURE' | translate}}">
                        </itec-checkbox>
                    </div>

                      <div class="mdl-cell mdl-cell--2-col">
                        <itec-checkbox
                            name="add"
                            ng-model="object.add"
                            ng-change-function="ctrl.onChangeAddTheme(object)"
                            label="{{::'DEFAULT_AFEGIR' | translate}}">
                        </itec-checkbox>
                    </div>

                    <div class="mdl-cell mdl-cell--2-col">
                        <itec-checkbox
                            name="edit"
                            ng-model="object.edit"
                            ng-change-function="ctrl.onChangeEditTheme(object)"
                            label="{{::'DEFAULT_EDITAR' | translate}}">
                        </itec-checkbox>
                    </div>


                    <div class="mdl-cell mdl-cell--2-col">
                        <itec-checkbox
                            name="delete"
                            ng-model="object.delete"
                            ng-change-function="ctrl.onChangeDeleteTheme(object)"
                            label="{{::'DEFAULT_ESBORRAR' | translate}}">
                        </itec-checkbox>
                    </div>

                </div>
            </span>

        </div>
    </div>
</itec-tree>
<div class="tcqi--margin-bottom-30"></div>
